import { render, staticRenderFns } from "./picsDetail.vue?vue&type=template&id=a3aceb26&scoped=true&"
import script from "./picsDetail.vue?vue&type=script&lang=js&"
export * from "./picsDetail.vue?vue&type=script&lang=js&"
import style0 from "./picsDetail.vue?vue&type=style&index=0&id=a3aceb26&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3aceb26",
  null
  
)

export default component.exports